import React, { useState, useEffect } from "react";
import { gameService } from "../../services/game.service";
import { Game } from "../../interfaces/game.interface";
import { Col, Row } from "antd";
import { DefaultLayout } from "../../layouts/DefaultLayout";
import { RightIcon } from "../../components/atoms/Icons";
import { goBack } from "../../utilities/CustomRoute/Navigate";
import { CarouselGameDetail } from "../../components/atoms/Carousel";
import CardBoard from "../../components/atoms/CardBoard";
import { userStore } from "../../gStore/user.store";
import { leaderboardService } from "../../services/leaderboard.service";
import { Leaderboard } from "../../interfaces/leaderboard.interface";
import {
  AttachSuffixToRank,
  DescriptionFormater,
} from "../../utilities/formatter";
import { filterList } from "../../constant";
import { useGameNavigator } from "../../hooks/useGameNavigator";
import { GameFeedback } from "../../components/atoms/GameFeedback";
import { RatingStars } from "../../components/RatingStars";

export const GameDetail = () => {
  const [gameId, setGameId] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(true);
  const [game, setGame] = useState<Game>();
  const [selfLeaderboard, setSelfLeaderboard] = useState<Leaderboard>();
  const [selfLeaderboardRank, setSelfLeaderboardRank] = useState<number>(0);
  const [leaderboards, setLeaderboards] = useState<Leaderboard[]>();
  const [cntOfLinesOfDescription, setCntOfLinesOfDescription] =
    useState<number>(0);
  const [showFeedback, setShowFeedback] = useState(false);
  const [toogleDescription, settoogleDescription] = useState<boolean>(false);

  const { navigateToGame, isGamePlayable } = useGameNavigator(game);

  const toggleFeedback = () => {
    if (showFeedback) {
      setShowFeedback(false);
    } else {
      setShowFeedback(true);
    }
  };

  useEffect(() => {
    var queryParams = new URLSearchParams(window.location.search);
    setGameId(queryParams.get("gameId") || "");
  }, []);

  useEffect(() => {
    if (gameId) {
      gameService
        .getGameDetail(gameId, userStore.data.user.id)
        .then((_game) => {
          setGame(_game);
        })
        .finally(() => {
          setLoading(false);
        });
      leaderboardService
        .getAllLeaderboardPosition(userStore.data.user.id, gameId)
        .then((_leaderboards) => {
          setLeaderboards(_leaderboards);
          _leaderboards.forEach((_leaderboard, i) => {
            if (_leaderboard.user_id === userStore.data.user.id) {
              setSelfLeaderboard(_leaderboard);
              setSelfLeaderboardRank(i + 1);
            }
          });
        })
        .catch((err: any) => {
          setSelfLeaderboard(undefined);
        });
    }
  }, [gameId]);

  useEffect(() => {
    if (game?.description) {
      setCntOfLinesOfDescription(
        game.description.split("\n").length +
          (game.description.includes("Features:") ? 1 : 0)
      );
    }
  }, [game?.description]);

  return (
    <DefaultLayout title={game?.id}>
      {loading ? (
        <div className="w-full p-10 flex justify-center text-white">
          Loading...
        </div>
      ) : (
        <>
          <section className="py-8">
            <div className="container">
              <div className="flex items-center gap-3 mb-6">
                <div onClick={goBack} className="rotate-180 cursor-pointer">
                  <RightIcon />
                </div>
                <img
                  src={game?.thumbnail}
                  className="h-[76px] object-cover rounded-[6px]"
                  alt=""
                />
                <span className="font-bold text-[32px] text-white">
                  {game?.id}
                </span>
                {isGamePlayable && (
                  <button
                    className="ml-auto bg-green-300 rounded-md px-10 py-4 mb-4 font-bold"
                    onClick={() => navigateToGame()}
                  >
                    Play Now
                  </button>
                )}
              </div>

              <Row gutter={[16, 24]}>
                <Col span={24} md={12} lg={16}>
                  <CarouselGameDetail screenshots={game?.screenshots || []} />
                  <div className="bg-light-dark2 mt-6 p-6 rounded-[6px] relative">
                    <div
                      className={
                        "transition-all duration-500 " +
                        (toogleDescription
                          ? "max-h-screen"
                          : "max-h-[135px] overflow-hidden")
                      }
                    >
                      <h5 className="font-bold text-[14px] text-white mb-4">
                        Game Description
                      </h5>

                      <div
                        className="text-[12px] text-white mb-3"
                        dangerouslySetInnerHTML={{
                          __html: DescriptionFormater(game?.description || ""),
                        }}
                      />
                    </div>
                    {cntOfLinesOfDescription > 2 && (
                      <div className="p-4 pb-0 w-full">
                        <div
                          className="flex justify-center gap-2 cursor-pointer"
                          onClick={() =>
                            settoogleDescription((_prev) => !_prev)
                          }
                        >
                          <span className="font-bold text-[12px] text-white">
                            {toogleDescription ? "View less" : "Read More"}
                          </span>
                          <div
                            className={
                              "transition-all duration-500 " +
                              (toogleDescription ? "-rotate-90" : "rotate-90")
                            }
                          >
                            <RightIcon color="white" />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </Col>
                <Col span={24} md={12} lg={8}>
                  <div className="relative w-full">
                    <div className="max-h-[800px] overflow-auto scrolStyle px-4">
                      <div className="mb-4">
                        <h3 className="font-bold text-[20px] text-white mb-3">
                          Rate this game
                        </h3>
                        <RatingStars game={game} onGameUpdate={setGame} />
                      </div>
                      <div className="mb-4">
                        <h3 className="font-bold text-[20px] text-white mb-3">
                          Game Details
                        </h3>
                        <div className="w-full p-4 bg-light-dark2 rounded-lg">
                          <div className="flex items-center justify-between">
                            <h5 className="font-bold text-[14px]">Category</h5>
                            <span className="font-medium text-[12px] capitalize flex items-center gap-2">
                              {(
                                Object.values(
                                  filterList.filter((categoryObj) =>
                                    (game?.category ?? "")
                                      .toLocaleLowerCase()
                                      .includes(
                                        categoryObj.title.toLocaleLowerCase()
                                      )
                                  )[0] ?? {}
                                ) ?? []
                              ).map((val) => val)}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="mb-4">
                        <div className="mb-4 flex justify-center">
                          <button
                            className={
                              "shadow hover:bg-purple-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded" +
                              (showFeedback
                                ? " bg-purple-400"
                                : " bg-green-300")
                            }
                            onClick={toggleFeedback}
                          >
                            <h4 className="font-bold text-[14px] text-white cursor-pointer">
                              Report Problem with Game
                            </h4>
                          </button>
                        </div>
                        <div
                          className={
                            "w-full p-4 bg-light-dark2 rounded-lg" +
                            (showFeedback ? "" : " hidden")
                          }
                        >
                          <div className="flex items-center justify-between">
                            <GameFeedback
                              gameId={gameId}
                              game={game}
                              setShowFeedback={setShowFeedback}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="">
                        <h4 className="font-bold text-[14px] text-white mb-3">
                          Leaderboard
                        </h4>

                        <div className="p-6 bg-light-dark2 rounded-lg text-center">
                          <img
                            src={userStore.data.user.avatar}
                            className="w-[82px] h-[82px] mx-auto rounded-full object-cover"
                            alt=""
                          />
                          <h5 className="font-bold text-[24px] my-2">
                            {userStore.data.user.first_name} {userStore.data.user.last_name}
                          </h5>
                          <div className="flex items-center justify-center gap-3">
                            {selfLeaderboard ? (
                              <>
                                <div className="p-3 rounded-lg bg-[#8dca8333] min-w-[80px]">
                                  <h5 className="font-medium text-[18px]">
                                    Place
                                  </h5>
                                  <h4 className="font-bold text-[24px] text-[#46D27E]">
                                    <span className="font-medium text-[14px]">
                                      {AttachSuffixToRank(selfLeaderboardRank)}
                                    </span>
                                  </h4>
                                </div>
                                <div className="p-3 rounded-lg bg-[#8dca8333] min-w-[80px]">
                                  <h5 className="font-medium text-[18px]">
                                    Score
                                  </h5>
                                  <h4 className="font-bold text-[24px] text-[#46D27E]">
                                    {selfLeaderboard.score}
                                  </h4>
                                </div>
                              </>
                            ) : (
                              <>
                                <p>
                                  Have you played <b>{gameId}</b>?
                                </p>
                              </>
                            )}
                          </div>
                        </div>
                      </div>

                      <hr className="my-6 !border-white" />

                      <div className="flex flex-wrap gap-4">
                        {leaderboards?.map((_leaderboard, i) => (
                          <CardBoard {..._leaderboard} rank={i + 1} key={i} />
                        ))}
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </section>
        </>
      )}
    </DefaultLayout>
  );
};
